<template>
    <div id="container-wrap-popup" :class="`type-${popupType}`">
        <div id="popup-dimmed-bg" v-on:click.self="handleClickClose">
            <div id="simple-popup-container">
                
                <template v-if="popupType == 'message' || popupType == 'CA01' || popupType == 'no-accountId'">
                    <div class="simple-popup-info">
                        
                        <div class="popup-title-l" v-if='false'>알림</div>
                        <div class="popup-text comment-text alert-message" v-html="popupMessage">
                            <!--{{popupMessage}} -->
                        </div>
                    </div>
                </template>
<!--
                <template v-else-if="popupType == 'messagewitherrorcode'">
                    <div class="simple-popup-info">
                        
                        <div class="popup-title-l">오류</div>
                        <div class="popup-text comment-text alert-message-errorcode" v-html="popupMessage">
                        </div>
                    </div>
                </template>

                <template v-else-if="popupType == 'message_otherappgooglelogin'">
                    <div class="simple-popup-info">
                        
                        <div class="popup-title-l">알림</div>
                        <div class="popup-text comment-text otherappgooglelogin" v-html="popupMessage">
                        </div>
                    </div>
                </template>

                <template v-else-if="popupType == 'emailauthalert'">
                    <div class="simple-popup-info">
                        
                        <div class="popup-title-l">이메일 인증</div>
                        <div class="popup-text comment-text">
                            계정의 이메일 주소로 인증 메일을 발송합니다.
                        </div>
                        <div class="email-text comment-title-s">
                            {{popupMessage}}
                        </div>
                    </div>
                </template>
-->
                <template v-else-if="popupType == 'loading'">
                    <div class="simple-popup-info">
                        <div class="popup-title-l" v-if="false">{{popupMessage}}</div>
                        <div class="popup-text comment-text" v-if="false">
                            {{popupMessage}}
                        </div>
                        <div class="email-text comment-title-s" style="margin-top:0;margin-bottom:0;">
                            {{popupMessage}}
                        </div>
                    </div>
                </template>

                <template v-else-if="popupType == 'needlogin'">
                    <div class="simple-popup-info">
                        <div class="popup-title-l" v-if='false'>알림</div>
                        <div class="popup-text comment-text alert-message" style='height:auto;'>
                            {{popupMessage}}
                        </div>
                    </div>
                </template>
<!--
                <template v-if="popupType == 'emailauthalert'">
                    <div id="check-button">
                        <input :class="['red-btn-popup', buttonClicked ? 'button-disabled' : '']" type="button" value="인증 메일 발송" v-on:click="handleClickEmailAuth">
                    </div>
                </template>
-->
                <template v-if="popupType == 'needlogin'">
                    <div id="close-button">
                        <input class="blue-btn-popup" type="button" :value="l10.All_Parents_Signin_Title1_Button1" v-on:click="handleClickLogin">
                    </div>
                </template>
                <template v-else-if="popupType == 'CA01' || popupType == 'no-accountId'">
                    <div id="close-button">
                        <input class="blue-btn-popup" type="button" :value="l10.All_Parents_FindPassword_Title1_Button2" v-on:click="handleClickClose">
                    </div>
                </template>
                <template v-else-if="popupType != 'loading'">
                    <div id="close-button" :class="[popupType == 'message' || popupType == 'messagewitherrorcode' ? 'alert-close' : '']">
                        <input class="blue-btn-popup" type="button" :value="l10.All_Parents_FindPassword_Title1_Button2" v-on:click="handleClickClose">
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>
<script>
    import { isMobileOnly  } from 'mobile-device-detect'
    export default {
        name: 'messagepopup',
        props: ['popupType', 'popupMessage'],
        created() {
            if (this.popupType == 'needlogin') {
                this.$store.commit('delIds');
            }
        },
        data() {
            const text = require("../../text/parent/laptop.js").default;
            const l10n = text[this.$store.state.lang]
                ? text[this.$store.state.lang]
                : text["en"];
            return {
                l10:l10n,
                buttonClicked: false,
            }
        },
        mounted() {
            document.body.style.overflow = 'hidden'
        },
        beforeDestroy() {
            if (document.getElementById('changepassword-popup-container')) return
            document.body.style.overflow = ''
        },
        methods: {
            handleClickClose() {
                if (this.popupType == 'loading') return
                if (this.popupType == 'messagewitherrorcode') {
                    this.$emit('handle-button')
                } else if(this.popupType == 'CA01' || this.popupType == 'no-accountId') {
                    this.$router.push('/signout?ref=error-'+this.popupType)
                } else {
                    this.$emit('close-popup')
                }
            },
            handleClickEmailAuth() {
                if (this.buttonClicked) return
                this.buttonClicked = true
                this.$emit('handle-button', 'emailauth')
            },
            handleClickLogin() {
                this.$router.push('/signin?redirect=' + this.$route.path)
            }
        },
    }
</script>
<!--
<style src="@/assets/common/style.css"></style>
<style src="@/assets/mypage/accountinfo/accountinfo.css" scoped></style>
<style src="@/assets/account/pai_popup_style.css" scoped></style>
-->

<style scoped>
    #popup-dimmed-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);

        position: fixed;
        top: 0;
    }

    #container-wrap-popup {
        position: fixed;
        z-index: 2000;
        height: 100%;
        width: 100%;
    }
    #simple-popup-container {
        position: fixed;
        top: 50%;
        left: 50%;
        background-color: #fff;
        padding: 28px;
        border-radius: 14px;
        transform : translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        width : 460px;
        box-sizing: border-box;
        text-align: center;
        box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.05);
    }

    #close-button {
        margin: 0 auto;
    }

    .alert-message {
        font-size: 28px;
        word-break: keep-all;
        padding: 0 15px;
        margin-top: 15px;
    }

    .alert-message-errorcode {
        font-size: 24px;
        height: 140px;
        word-break: keep-all;
        padding: 0 15px;
        margin-top: 15px;
    }

    .alert-close {
        margin-top: 0px !important;
    }

    .messagewitherrorcode-close {
        margin-top: 0px !important;
    }

    .button-disabled {
        opacity: 0.5;
        cursor: default;
    }

    .otherappgooglelogin {
        font-size: 16px;
    }

    #red-btn-popup {
        margin: 0 auto;
        text-align: center;
    }

    .red-btn {
        width: 272px;
        height: 72px;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        border: 0 !important;
        cursor: pointer;
    }

    .popup-title-l {
        font-size: 36px;
        line-height: 1.56;
        letter-spacing: -1px;
        margin-bottom: 18px;
        display: none !important;
    }

    .blue-btn-popup {
        width: 260px;
        height: 60px;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        border: 0 !important;
        cursor: pointer;
        margin-top: 50px;
        background-color: #42c0ff;
        border-radius: 18px;
    }


    @media screen and (max-width: 720px) {
        #container-wrap-popup {
            margin: 0 auto;
        }
        #simple-popup-container {
            width: 592px; height: auto;
            box-sizing: content-box;
            border-radius: 24px;
        }

        .otherappgooglelogin {
            font-size: 24px;
            height: auto;
        }

        .coupon-complete {
            font-size: 36px;
            line-height: 1.55em;
        }
        .coupon-complete p{
            font-size: 28px;
        }

        #close-button {
            width: 100%;
        }

        .alert-message {
            font-size: 38px;
            word-break: keep-all;
            padding: 0 15px;
            margin-top: 10px;
        }

        .alert-message-errorcode {
            margin-top: 10px;
        }
    
         #red-btn-popup {
            margin-top: 50px;
            margin-bottom: 100px;
        }

        .red-btn {
            /* background: url("./img-red-btn-long-m.png");  */
            width: 656px;
            height: 106px;
            font-size: 28px;
        }

        .popup-title-l {
            font-size: 42px;
            line-height: 1.56;
            letter-spacing: -1px;
            margin-bottom: 36px;
        }

        .blue-btn-popup {
            width: 592px;
            height: 106px;
            font-size: 28px;
            font-weight: 600;
        }

        .blue-btn-popup {
            font-size: 42px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/account/SimplePopup.vue